module.exports = __webpack_public_path__ + "static/media/in_out.65cce618.png";